import { getQueue, removeFromQueue } from "./offlineQueue";

export const syncPendingOperations = async () => {
  const queue = await getQueue();
  const pending = queue.filter((i) => i.status === "pending");

  if (pending.length === 0) return { success: 0, failed: 0 };

  const token = localStorage.getItem("token");
  if (!token) return { success: 0, failed: 0 };

  let success = 0;
  let failed = 0;

  for (const item of pending) {
    try {
      const response = await fetch(
        `https://stocksense-backend-g1kp.onrender.com${item.url}`,
        {
          method: item.method,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: item.data ? JSON.stringify(item.data) : undefined,
        }
      );

      if (response.ok) {
        await removeFromQueue(item.id);
        success++;
      } else {
        failed++;
      }
    } catch {
      failed++;
    }
  }

  return { success, failed };
};